export function getPricingInputClassName({ hasError }: { hasError: boolean }) {
  return `block w-full rounded-md shadow-sm disabled:cursor-not-allowed sm:text-sm ${
    hasError
      ? 'border-red-300 focus:border-red-300 focus:ring-red-500'
      : 'focus:border-indigo-500 focus:ring-indigo-500 border-gray-300'
  }`;
}
